import { SelectOption } from "../interfaces/selectOption.ts";

export const TitleSelectOptions: SelectOption[] = [
  { value: "m", label: "Herr" },
  { value: "f", label: "Frau" },
  { value: "d", label: "Divers" },
];
